module.exports = __webpack_public_path__ + "img/5.56d86642.svg";